import { helpers, required, requiredIf } from "@vuelidate/validators";
import validationJson from "~/static/locale/it/validation.json";
import Validator from "~/utils/validator";

// get generic validation locale merged with theme defined validation locale
const { locale } = await useLocale("validation", null, true);

export default {
  installmentDebitDay: {
    required: helpers.withMessage(
      () => locale?.value?.required ?? validationJson.required,
      required,
    ),
  },
  politicallyExposedPerson: {
    required: helpers.withMessage(
      () => locale?.value?.required ?? validationJson.required,
      //@ts-ignore
      requiredIf(function (value: boolean, { showPEPExplanation }: any) {
        return showPEPExplanation;
      }),
    ),
  },
  buyClubSelection: {
    required: helpers.withMessage(
      () => locale?.value?.required ?? validationJson.required,
      //@ts-ignore
      requiredIf(function (value: any, { showClubUpsell }: any) {
        return showClubUpsell;
      }),
    ),
  },
  buyCyberSelection: {
    required: helpers.withMessage(
      () => locale?.value?.required ?? validationJson.required,
      //@ts-ignore
      requiredIf(function (value: any, { showCyberUpsell }: any) {
        return showCyberUpsell;
      }),
    ),
  },
  consent_cyber_main: {
  required: helpers.withMessage(
    validationJson.club_consent_error,
    //@ts-ignore
    requiredIf(function (value: any, { showCyberUpsell, buyCyberSelection }: any) {
      return showCyberUpsell && buyCyberSelection.value === true;
    }),
  ),
  mustBeTrue: helpers.withMessage(
    validationJson.club_consent_error,
    //@ts-ignore
    (value: any, { showCyberUpsell, buyCyberSelection }: any) => {
      if (!showCyberUpsell || buyCyberSelection.value !== true) return true;
      return Validator.mustBeTrue(value);
    },
  ),
},
consent_cyber1: {
  required: helpers.withMessage(
    validationJson.club_consent_error,
    //@ts-ignore
    requiredIf(function (value: any, { showCyberUpsell, buyCyberSelection }: any) {
      return showCyberUpsell && buyCyberSelection.value === true;
    }),
  ),
  mustBeTrue: helpers.withMessage(
    validationJson.club_consent_error,
    //@ts-ignore
    (value: any, { showCyberUpsell, buyCyberSelection }: any) => {
      if (!showCyberUpsell || buyCyberSelection.value !== true) return true;
      return Validator.mustBeTrue(value);
    },
  ),
},
consent_cyber2: {
  required: helpers.withMessage(
    validationJson.club_consent_error,
    //@ts-ignore
    requiredIf(function (value: any, { showCyberUpsell, buyCyberSelection }: any) {
      return showCyberUpsell && buyCyberSelection.value === true;
    }),
  ),
  mustBeTrue: helpers.withMessage(
    validationJson.club_consent_error,
    //@ts-ignore
    (value: any, { showCyberUpsell, buyCyberSelection }: any) => {
      if (!showCyberUpsell || buyCyberSelection.value !== true) return true;
      return Validator.mustBeTrue(value);
    },
  ),
},
consent_cyber3: {
  required: helpers.withMessage(
    validationJson.club_consent_error,
    //@ts-ignore
    requiredIf(function (value: any, { showCyberUpsell, buyCyberSelection }: any) {
      return showCyberUpsell && buyCyberSelection.value === true;
    }),
  ),
  mustBeTrue: helpers.withMessage(
    validationJson.club_consent_error,
    //@ts-ignore
    (value: any, { showCyberUpsell, buyCyberSelection }: any) => {
      if (!showCyberUpsell || buyCyberSelection.value !== true) return true;
      return Validator.mustBeTrue(value);
    },
  ),
},

  iban: {
    required: helpers.withMessage(
      () => locale?.value?.required ?? validationJson.required,
      required,
    ),
    validIBAN: helpers.withMessage(
      () => locale?.value?.invalid_iban ?? validationJson.invalid_iban,
      Validator.validIban,
    ),
    notPrepaidIBAN: helpers.withMessage(
      () => locale?.value?.invalid_iban ?? validationJson.invalid_iban,
      Validator.notPrepaidIban,
    ),
    requiredABI: helpers.withMessage(
      () => {
        if (locale?.value?.invalid_abi) return locale?.value?.invalid_abi
        return locale?.value?.invalid_iban ?? validationJson.invalid_iban
      },
      (value: string, { requiredABI }: any) => {
        if (!requiredABI) return true
        return Validator.requiredABI(value, requiredABI)
      },
    )
  },
};
